export const formatWidthHeight = (w, h) => (w < h ? `${w}×${h}` : `${h}×${w}`);

export default {};
